var _toConsumableArray = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

var _regeneratorRuntime = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

var $78605a5d7424e31b$exports = require("./useLayoutEffect.main.js");

var $19a2307bfabafaf1$exports = require("./useValueEffect.main.js");

var $dG5aF$react = require("react");

var $dG5aF$reactariassr = require("@react-aria/ssr");

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

$parcel$export(module.exports, "useId", function () {
  return $8c61827343eed941$export$f680877a34711e37;
});
$parcel$export(module.exports, "mergeIds", function () {
  return $8c61827343eed941$export$cd8c9cb68f842629;
});
$parcel$export(module.exports, "useSlotId", function () {
  return $8c61827343eed941$export$b4cc09c592e8fdb8;
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
// copied from SSRProvider.tsx to reduce exports, if needed again, consider sharing

var $8c61827343eed941$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
var $8c61827343eed941$export$d41a04c74483c6ef = new Map(); // This allows us to clean up the idsUpdaterMap when the id is no longer used.
// Map is a strong reference, so unused ids wouldn't be cleaned up otherwise.
// This can happen in suspended components where mount/unmount is not called.

var $8c61827343eed941$var$registry;
if (typeof FinalizationRegistry !== 'undefined') $8c61827343eed941$var$registry = new FinalizationRegistry(function (heldValue) {
  $8c61827343eed941$export$d41a04c74483c6ef.delete(heldValue);
});

function $8c61827343eed941$export$f680877a34711e37(defaultId) {
  var _ref = (0, $dG5aF$react.useState)(defaultId),
      _ref2 = _slicedToArray(_ref, 2),
      value = _ref2[0],
      setValue = _ref2[1];

  var nextId = (0, $dG5aF$react.useRef)(null);
  var res = (0, $dG5aF$reactariassr.useSSRSafeId)(value);
  var cleanupRef = (0, $dG5aF$react.useRef)(null);
  if ($8c61827343eed941$var$registry) $8c61827343eed941$var$registry.register(cleanupRef, res);

  if ($8c61827343eed941$var$canUseDOM) {
    var cacheIdRef = $8c61827343eed941$export$d41a04c74483c6ef.get(res);
    if (cacheIdRef && !cacheIdRef.includes(nextId)) cacheIdRef.push(nextId);else $8c61827343eed941$export$d41a04c74483c6ef.set(res, [nextId]);
  }

  (0, $78605a5d7424e31b$exports.useLayoutEffect)(function () {
    var r = res;
    return function () {
      // In Suspense, the cleanup function may be not called
      // when it is though, also remove it from the finalization registry.
      if ($8c61827343eed941$var$registry) $8c61827343eed941$var$registry.unregister(cleanupRef);
      $8c61827343eed941$export$d41a04c74483c6ef.delete(r);
    };
  }, [res]); // This cannot cause an infinite loop because the ref is always cleaned up.
  // eslint-disable-next-line

  (0, $dG5aF$react.useEffect)(function () {
    var newId = nextId.current;
    if (newId) setValue(newId);
    return function () {
      if (newId) nextId.current = null;
    };
  });
  return res;
}

function $8c61827343eed941$export$cd8c9cb68f842629(idA, idB) {
  if (idA === idB) return idA;
  var setIdsA = $8c61827343eed941$export$d41a04c74483c6ef.get(idA);

  if (setIdsA) {
    setIdsA.forEach(function (ref) {
      return ref.current = idB;
    });
    return idB;
  }

  var setIdsB = $8c61827343eed941$export$d41a04c74483c6ef.get(idB);

  if (setIdsB) {
    setIdsB.forEach(function (ref) {
      return ref.current = idA;
    });
    return idA;
  }

  return idB;
}

function $8c61827343eed941$export$b4cc09c592e8fdb8() {
  var depArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var id = $8c61827343eed941$export$f680877a34711e37();

  var _ref3 = (0, $19a2307bfabafaf1$exports.useValueEffect)(id),
      _ref4 = _slicedToArray(_ref3, 2),
      resolvedId = _ref4[0],
      setResolvedId = _ref4[1];

  var updateId = (0, $dG5aF$react.useCallback)(function () {
    setResolvedId( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return id;

          case 2:
            _context.next = 4;
            return document.getElementById(id) ? id : undefined;

          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  }, [id, setResolvedId]);
  (0, $78605a5d7424e31b$exports.useLayoutEffect)(updateId, [id, updateId].concat(_toConsumableArray(depArray)));
  return resolvedId;
}